"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.picker.tooltip': 'Elige archivos para que use el asistente de IA o agrega los tuyos',
    'knowledge.picker.search.mode': 'Modo de Búsqueda',
    'knowledge.picker.search.knowledge': 'Entradas de Conocimiento',
    'knowledge.picker.search.projects': 'Proyectos',
    'knowledge.picker.search.knowledge.label': 'Buscar Entradas de Conocimiento - asignar conocimiento al avatar',
    'knowledge.picker.search.knowledge.placeholder': 'Buscar entradas de conocimiento...',
    'knowledge.picker.search.projects.label': 'Buscar Proyectos - asignar proyecto al avatar',
    'knowledge.picker.search.projects.placeholder': 'Buscar proyectos...',
    'knowledge.picker.search.clear': 'Limpiar búsqueda',
    'knowledge.picker.selected.knowledge': 'Entradas de Conocimiento Seleccionadas',
    'knowledge.picker.selected.projects': 'Proyectos Seleccionados',
    'knowledge.picker.table.name': 'Nombre',
    'knowledge.picker.table.project': 'Proyecto',
    'knowledge.picker.table.format': 'Formato',
    'knowledge.picker.table.size': 'Tamaño',
    'knowledge.picker.table.description': 'Descripción',
    'knowledge.picker.remove': 'Eliminar',
    'knowledge.picker.confirmRemove': '¿Está seguro de que desea eliminar esta entrada de conocimiento?',
    'knowledge.picker.no.results': 'No se encontraron elementos',
    'knowledge.picker.1to1mode': 'Modo 1:1 (Contenido completo)',
};
